<template>
	<div>
		<h3>{{ $t('MAIN_CONTENT.thirdPartyAccess.manageThirdPartyAccess') }}</h3>
		<div>
			<p>{{ $t('MAIN_CONTENT.thirdPartyAccess.description') }}</p>
		
		</div>
		<div class="alert alert-info" v-if="clients.length === 0">
			<p>{{ $t('MAIN_CONTENT.thirdPartyAccess.noClientsMessage') }}</p>
		</div>
		<div class="row" v-if="clients.length > 0">
			<div class="col-md-6 hidden-sm hidden-xs">
				<h4>{{ $t('MAIN_CONTENT.thirdPartyAccess.client') }}</h4>
			</div>
			<div class="col-md-2 hidden-sm hidden-xs">
				<h4>{{ $t('MAIN_CONTENT.thirdPartyAccess.accessGranted') }}</h4>
			</div>
			<div class="col-md-2 hidden-sm hidden-xs">
				<h4>{{ $t('MAIN_CONTENT.thirdPartyAccess.lastUsed') }}</h4>
			</div>
			<div class="col-md-2 hidden-sm hidden-xs">
				&nbsp;
			</div>
		</div>
		<div class="panel panel-default" v-for="client in clients">
			<div class="panel-body">
				<div class="col-md-6">
					<h5>{{client.CLIENT_NAME}}</h5>
				</div>
				<div class="col-md-2">
					<h5>{{client.ACCESS_GRANTED_DATE | datetime}}</h5>
				</div>
				<div class="col-md-2">
					<h5>{{client.LAST_USED_DATE | datetime}}</h5>
				</div>
				<div class="col-md-2 text-right">
					<a href="javascript: void(0);" @click="revokeAccess(client.CLIENT_ID)" class="btn btn-sm btn-danger">{{ $t('MAIN_CONTENT.thirdPartyAccess.revokeAccess') }}</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ThirdPartyAccess from '../../api/ThirdPartyAccess';
	import PanelBasic from 'COMMONS/panels/PanelBasic.vue';

	export default {
		data() {
			return {
				clients: [],
			}
		},
		components: {
			PanelBasic
		},
		methods: {
			revokeAccess(clientId){
				const self = this;
				const messageText = this.$t('MAIN_CONTENT.thirdPartyAccess.confirmRevokeAccessMessage');
				this.$modal.confirm(messageText, { title: this.$t('MAIN_CONTENT.thirdPartyAccess.confirmRevokeAccessTitle'), okText: this.$t('MAIN_CONTENT.thirdPartyAccess.revokeAccess'), cancelText: this.$t('commonText.cancel')}).then(ans => {
					if( ans ){
						let thirdPartyAccess = new ThirdPartyAccess({
							routeParams: {
								"clientId": clientId,
							}
						});

						thirdPartyAccess.delete().then(response => {
							self.fetchClientsList();
						});
					}
				});
			},
			fetchClientsList() {
				const self = this;

				let thirdPartyAccess = new ThirdPartyAccess({});

				thirdPartyAccess.get().then(response => {
					self.clients = thirdPartyAccess.getResponseData();
				})
				.catch(error => {
					self.clients = [];
				});
			},
		},
		created() {
			this.$store.commit('setTitleIcon', 'key');
			this.$store.commit('setTitle', 'MAIN_CONTENT.thirdPartyAccess.thirdPartyAccess');
			this.$store.commit('setUseHeader', true);
			this.fetchClientsList();
		}
	}
</script>
